import * as React from "react";
import "./Button.css";

type ButtonProps = {
  children: React.ReactNode;
  disabled?: boolean;
  onClick?(): void;
  buttonClass?: "primary" | "secondary" | "link";
  className?:string;
  type?: 'submit' | 'reset' | 'button' | undefined;
};

export default function Button({
  children,
  disabled,
  onClick,
  buttonClass = "primary",
  className,
  type,
}: ButtonProps) {
  //const class="hover:text-spr-white disabled:cursor-default disabled:"
  // const className =
  //   type === "primary"
  //     ? "bg-spr-white text-spr-black uppercase py-1.5 px-3.5 hover:bg-spr-green hover:text-spr-white font-medium font-semibold hover:border-spr-green border-spr-black border rounded disabled:cursor-default"
  //     : "bg-spr-black text-spr-white uppercase py-1 px-3.5 hover:bg-spr-green font-helvetica hover:border-spr-green border-spr-black border disabled:cursor-default ";
  const classNameConst = `btn btn-${buttonClass} ${className}`;
  return (
    <button onClick={onClick} className={classNameConst} disabled={disabled} type={type}>
      {children}
    </button>
  );
}
